import { readRunDraft } from './cloud-run-draft';
import { campaignEntryDimensions } from './browser-check-context';
import { campaignDimensions, campaignKeys, safeFunnelContext } from '../../shared/funnel-analytics';
interface Client { get_property(key: string): unknown; get_distinct_id(): string; has_opted_out_capturing(): boolean }
export function browserFunnelContext(client: Client) {
  const properties: Record<string, unknown> = { anonymous_id: client.get_distinct_id(), is_test: client.get_property('is_test') === true || client.get_property('internal_or_test_user') === true };
  for (const prefix of ['', 'first_', 'session_']) for (const key of campaignKeys) properties[`${prefix}${key}`] = client.get_property(`${prefix}${key}`);
  for (const key of Object.keys(campaignDimensions)) properties[key] = client.get_property(key);
  // A fast auth handoff can occur before the landing's preference request resolves.
  // The saved task proves its entry variant; only fixed dimensions are recovered.
  if (!properties.landing_variant && readRunDraft()?.landingVariant === 'browser_check_v1' && typeof navigator !== 'undefined') Object.assign(properties, campaignEntryDimensions(navigator.userAgent));
  return safeFunnelContext(properties);
}
export function clearFunnelCookie() {
  try { document.cookie = 'rill_funnel=; Path=/; SameSite=Lax; Max-Age=0'; } catch { /* Storage unavailable. */ }
}
export function prepareAuthAnalytics(client: Client): Record<string, string | boolean> {
  try {
    if (client.has_opted_out_capturing() || navigator.webdriver || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl) { clearFunnelCookie(); return {}; }
    const context = { ...browserFunnelContext(client), auth_attempt_id: crypto.randomUUID() };
    document.cookie = `rill_funnel=${encodeURIComponent(JSON.stringify(context))}; Path=/; SameSite=Lax; Max-Age=900${location.protocol === 'https:' ? '; Secure' : ''}`;
    return { auth_attempt_id: context.auth_attempt_id };
  } catch { return {}; }
}
export async function syncFunnelContext(client: Client) {
  try {
    if (client.has_opted_out_capturing() || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl) return;
    const { anonymous_id: _anonymous, ...context } = browserFunnelContext(client);
    await fetch('/api/me/analytics-context', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(context) });
  } catch { /* Attribution must not block using the workspace. */ }
}
